import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course05 from "../../../course/course-05/course";
import lesson0506 from "../../../lesson/course-05/lesson-06/lesson";
import lesson0511 from "../../../lesson/course-05/lesson-11/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "edba0b6d-2655-4d3b-888f-8fddbfd0419c",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0506),
    lesson: lesson0506,
  },
  {
    id: "8dbdf1c7-3efe-411b-85aa-f29d5cac99aa",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0511),
    lesson: lesson0511,
  },
];

export default lessonLinks;
